import { MAX_AUDIO_DURATION_SECONDS } from 'shared/constants/limits'
import { type Attachment } from 'entities/Attachment/model/Attachment'
import {
  MAX_AUDIO_DURATION_RINGLESS_SELECT,
  MIN_AUDIO_DURATION_RINGLESS_SELECT,
} from 'widgets/MediaLibrary/constants/constants'

export const getAudioDurationDisabledInfo = (
  attachment: Attachment,
  {
    isRinglessDurationLimitEnabled,
    isAudioSelectDurationLimitEnabled,
  }: { isRinglessDurationLimitEnabled: boolean; isAudioSelectDurationLimitEnabled: boolean }
) => {
  const duration = attachment.duration
  const hasKnownDuration = typeof duration === 'number' && duration > 0

  const isTooShortForRingless =
    isRinglessDurationLimitEnabled &&
    hasKnownDuration &&
    duration < MIN_AUDIO_DURATION_RINGLESS_SELECT
  const isTooLongForRingless =
    isRinglessDurationLimitEnabled &&
    hasKnownDuration &&
    duration > MAX_AUDIO_DURATION_RINGLESS_SELECT
  const isTooLongForAudioSelect =
    isAudioSelectDurationLimitEnabled && hasKnownDuration && duration > MAX_AUDIO_DURATION_SECONDS

  const isTooShort = isTooShortForRingless
  const isDisabled = isTooShort || isTooLongForRingless || isTooLongForAudioSelect

  const disabledMessage = !isDisabled
    ? null
    : isTooShort
    ? "The file cannot be uploaded because it's less than 15-seconds limit."
    : 'The file cannot be uploaded because it exceeds the 3-minute limit.'

  return { isDisabled, isTooShort, disabledMessage }
}
